import { render, staticRenderFns } from "./EmployeeAddView.vue?vue&type=template&id=ca0f2bda"
import script from "./EmployeeAddView.vue?vue&type=script&lang=js"
export * from "./EmployeeAddView.vue?vue&type=script&lang=js"
import style0 from "./EmployeeAddView.vue?vue&type=style&index=0&id=ca0f2bda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports